import { useCommonTx } from '~/hooks/useTranslationForNamespace'

export const Science = () => {
  const t = useCommonTx('landing.science')
  return (
    <div
      className='relative p-0 min-h-[max(900px,100vh)] flex flex-col items-center w-full px-6 py-[8%] bg-center-bottom md:bg-center-top bg-size-900 md:bg-cover'
      style={{
        backgroundImage: "url('/assets/images/landing/gamesBackground.svg')",
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className='flex flex-col justify-center items-center text-center gap-3'>
        <div className='text-title-1 font-bold font-serif'>{t('header')}</div>
        <div className='text-body-text-1'>{t('body')}</div>
      </div>
      <div className='min-h-[600px]'></div>
    </div>
  )
}
